import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SocialMedia from "../components/SocialMedia";
import { useTranslation } from "react-i18next";
import aesa from "../Assets/AESA_Logo.webp";
import gobesp from "../Assets/gobesp.webp";
import easa from "../Assets/EASA_Logo.webp";
import { MdEmail, MdPhone } from "react-icons/md";
import { Link } from "react-router-dom";

function Footer() {
  const { t, i18n } = useTranslation();
  const basePath = i18n.language === "en" ? "/en" : "";
  
  let date = new Date();
  let year = date.getFullYear();
  return (
     <Container fluid className="footer">
        <Row>
           <Col md="6" className="footer-copywright">
              <h3>{t("aesa")}</h3>
              <div className="aesa">
                 <img
                    className="aesa-logos"
                    src={aesa}
                    alt="AESA logo"
                    title="AESA logo"
                    loading="lazy"
                 />
                 <img
                    className="aesa-logos"
                    src={gobesp}
                    alt="Gobierno de España logo"
                    title="Gobierno de España logo"
                    loading="lazy"
                 />
                 <img
                    className="aesa-logos"
                    src={easa}
                    alt="EASA logo"
                    title="EASA logo"
                    loading="lazy"
                 />
              </div>
           </Col>
           <Col md="3" className="footer-body">
              <h3>{t("social_media")}</h3>
              <SocialMedia />
           </Col>
           <Col md="3" className="footer-body">
              <h3>{t("contact")}</h3>
              <div className="contact-info-footer">
                 <MdEmail />
                 <p>falcon@joancompany.es</p>
              </div>
              <div className="contact-info-footer">
                 <MdPhone />
                 <p>+34 615 159 344</p>
              </div>
           </Col>
        </Row>
        <Row>
           <Col md="6" className="footer-terms">
              <p>
                 {t("developed_by")} | Copyright © {year}
              </p>
           </Col>
           <Col md="6" className="footer-terms">
              <p>
                 <Link to={`${basePath}/aviso-legal`} title={t("legal_notice")}>
                    {t("legal_notice")}
                 </Link>
                 {" | "}
                 <Link
                    to={`${basePath}/condiciones`}
                    title={t("terms_and_conditions")}
                 >
                    {t("terms_and_conditions")}
                 </Link>{" "}
                 |{" "}
                 <Link
                    to={`${basePath}/politica-privacidad`}
                    title={t("privacy_policy")}
                 >
                    {t("privacy_policy")}
                 </Link>
                 {" | "}
                 <Link to={`${basePath}/cookies`} title={t("cookies_policy")}>
                    {t("cookies_policy")}
                 </Link>
              </p>
           </Col>
        </Row>
     </Container>
  );
}

export default Footer;